/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import AOS from "aos";

const defaultVal = {
  pending: false,
  setPending: () => {},
  notification: null,
  setNotification: () => {},
  curPage: 0,
  setCurPage: () => {},
  onToggleTheme: () => {},
  theme: "light",
};

export const ProjectInfoContext = React.createContext(defaultVal);

export default function useProjectInfo() {
  return React.useContext(ProjectInfoContext);
}

export function ProjectInfoProvider({ children }) {
  const [pending, setPending] = useState(false);
  const [notification, setNotification] = useState(null);
  const [curPage, setCurPage] = useState(0);
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    AOS.init({ duration: 1000 });
    AOS.refresh();
  }, []);

  const onToggleTheme = () => {
    if (localStorage.getItem("color-theme")) {
      if (localStorage.getItem("color-theme") === "light") {
        document.documentElement.classList.add("dark");
        localStorage.setItem("color-theme", "dark");
      } else {
        document.documentElement.classList.remove("dark");
        localStorage.setItem("color-theme", "light");
      }

      // if NOT set via local storage previously
    } else {
      if (document.documentElement.classList.contains("dark")) {
        document.documentElement.classList.remove("dark");
        localStorage.setItem("color-theme", "light");
      } else {
        document.documentElement.classList.add("dark");
        localStorage.setItem("color-theme", "dark");
      }
    }
    getTheme();
  };

  const getTheme = () => {
    if (localStorage.getItem("color-theme")) {
      setTheme(localStorage.getItem("color-theme"));
      document.documentElement.classList.add(
        localStorage.getItem("color-theme")
      );
      // if NOT set via local storage previously
    } else {
      if (document.documentElement.classList.contains("dark")) {
        setTheme("dark");
      } else {
        setTheme("light");
      }
    }
  };
  useEffect(() => {
    getTheme();
  }, []);

  useEffect(() => {
    
  }, []);

  return (
    <ProjectInfoContext.Provider
      value={{
        pending,
        setPending,
        notification,
        setNotification,
        curPage,
        setCurPage,
        onToggleTheme,
        theme,
      }}
      children={children}
    />
  );
}
